<template>
  <filter-template @submit="filter()">
    <v-row class="py-6">
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <span>Data da transação</span>
            <v-row class="pt-2">
              <v-col cols="6">
                <input-date
                  id="input:InitialDate"
                  v-model="payload.InitialDate"
                  label="Inicial"
                />
              </v-col>
              <v-col cols="6">
                <input-date
                  id="input:FinalDate"
                  v-model="payload.FinalDate"
                  label="Final"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mt-10">
          <v-col cols="12">
            <input-select
              id="input:TransactionType"
              v-model="payload.TransactionType"
              label="Tipo de transação"
              :items="TransactionTypeOptions"
              clearable
            />
          </v-col>
        </v-row>
        <v-row class="mt-10">
          <v-col cols="12">
            <v-combobox
              id="input:TransactionOperations"
              v-model="payload.TransactionOperations"
              label="Operação"
              :items="TransactionOperationsOptions"
              multiple
              clearable
              outlined
            />
          </v-col>
        </v-row>
        <v-row class="mt-10">
          <v-col cols="12">
            <input-select
              id="input:PaymentMethod"
              v-model="payload.PaymentMethod"
              label="Tipo de pagamento"
              :items="PaymentMethodOptions"
              clearable
            />
          </v-col>
        </v-row>
        <v-row class="mt-10">
          <v-col cols="12">
            <input-select
              id="input:OperationType"
              v-model="payload.OperationType"
              label="Tipo de operação"
              :items="OperationTypeOptions"
              clearable
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </filter-template>
</template>

<script>
import FilterMixin from '@/app/arch/components/crud/crud-mixins/FilterMixin';
import FilterTemplate from '@/app/arch/components/crud/components/FilterTemplate.vue';
import StatementType from './StatementType';
import StatementOperation from './StatementOperation';
import StatementPaymentMethod from '../../../../../arch/enums/StatementPaymentMethod';
import StatementOperationType from './StatementOperationType';

export default {
  name: 'StatementFilter',
  components: { FilterTemplate },
  mixins: [FilterMixin],
  data: () => ({
    payload: {
      InitialDate: '',
      FinalDate: '',
      TransactionType: '',
      StatementType: '',
      TransactionOperations: '',
      PaymentMethod: '',
      OperationType: '',
      ClientId: '',
    },
    TransactionTypeOptions: StatementType,
    PaymentMethodOptions: StatementPaymentMethod,
    OperationTypeOptions: StatementOperationType,
    TransactionOperationsOptions: StatementOperation.map(
      (operation) => ({
        text: operation.text,
        value: operation.id,
      }),
    ),
  }),
  methods: {
    preparePayload() {
      return {
        ...this.payload,
        TransactionOperations: this.payload.TransactionOperations.length ? `${
          this.payload.TransactionOperations.map((s) => s.value)
        }` : this.payload.TransactionOperations,
      };
    },
    prepareQuery(query) {
      return {
        ...query,
        TransactionOperations: query && query.TransactionOperations
          ? query.TransactionOperations.split(',') : [],
      };
    },
  },
};
</script>
